import {GroupAnimation} from './GroupAnimation';
import {BaseAnimation} from './BaseAnimation';

export class BaseAnimations extends GroupAnimation {

    constructor(e:JQuery|string) {
        let anims:BaseAnimation[]=[];
        var ex=(typeof e=='string')?$(e):e;
        ex.not('.from,.to').each(
            (idx,e)=>{
                anims.push(new BaseAnimation($(e)));
            }
        );
        super(...anims);
    }

}

export {};